<h2 mat-dialog-title>בחר תוויות</h2>
<mat-dialog-content>
  <app-group-labels (selectionChanged)="onSelectionChange($event)"></app-group-labels>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">ביטול</button>
  <button mat-raised-button color="primary" (click)="onSave()">אישור</button>
</mat-dialog-actions>